import * as GenericAppComponents from '@components/generic/app';

export const mdxComponents = GenericAppComponents;
